export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/auth/login-page';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin/dashboard';